export const labels = {
  title: {
    noDebt: 'Du har ingen gjeld å refinansiere!',
    refinanceableDebts: 'Spar penger hver måned ved å refinansiere!',
  },
  description: {
    noDebt:
      'Gjeld som kan refinansieres inkluderer gjeld opptil 800 000 kr med rente over 8% og all kredittkortbruk over 25 000 kr. Vi fant ingen gjeld å refinansiere, og du er straks ferdig med lånesøknaden. Bruk skyveknappen under for å bekrefte ønsket lånebeløp.',
    refinanceableDebts:
      'Vi har identifisert gjeld som du kan samle i ett lån med lavere rente. Dette vil redusere dine månedlige kostnader og gi deg bedre kontroll over økonomien. De forhåndsvalgte boksene viser hvilke lån du kan refinansiere. Bruk skyveknappen lenger ned for å velge hvor mye ekstra du ønsker å låne.',
  },
};
